// extracted by mini-css-extract-plugin
export var quantityInput = "_gw-0";